import { render } from "./CrudLicencaOrgao.vue?vue&type=template&id=66db21ac&scoped=true"
import script from "./CrudLicencaOrgao.vue?vue&type=script&lang=ts"
export * from "./CrudLicencaOrgao.vue?vue&type=script&lang=ts"

import "./CrudLicencaOrgao.vue?vue&type=style&index=0&id=66db21ac&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-66db21ac"

export default script